export default {
    title: '仪表盘',
    route: {
        index: 'Index',
        account: 'Account Manage',
        role: 'Role Manage',
        group: 'Group Manage',
        resource: 'Resource Manage',
        app: 'Application Manage',
        data_type: 'Data Type',
        laseholder: 'Laseholder Manage',
        laseholderGroup: 'Laseholder Group',
        UrlBlackWhite: 'URL Black White List',
        PostManage: 'Post Manage'
    }
};